import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

// #design-pass: Pill-Badges mit tone-Tokens (ok/info/warn/danger/muted/accent),
// jeweils -bg/-border statt alpha (Light+Dark-tauglich).
const badgeVariants = cva(
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold",
  {
    variants: {
      variant: {
        default: "border-muted-border bg-muted-bg text-muted",
        outline: "border-border bg-transparent text-text2",
        destructive: "border-danger-border bg-danger-bg text-danger",
        online: "border-ok-border bg-ok-bg text-ok",
        offline: "border-muted-border bg-muted-bg text-muted",
        active: "border-ok-border bg-ok-bg text-ok",
        disabled: "border-muted-border bg-muted-bg text-muted",
        // #185: Channel-Status enrolled/online sind beide healthy.
        enrolled: "border-info-border bg-info-bg text-info",
        revoked: "border-danger-border bg-danger-bg text-danger",
        available: "border-ok-border bg-ok-bg text-ok",
        busy: "border-warn-border bg-warn-bg text-warn",
        orphaned: "border-muted-border bg-muted-bg italic text-muted",
        "session-active": "border-accent-border bg-accent-soft text-accent-text",
        "session-idle": "border-muted-border bg-muted-bg text-muted",
        "session-archived": "border-muted-border bg-muted-bg text-muted",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
